import React from 'react';
import { Box } from '@mui/material';
import LoadingBook from '../LoadingBook';
import { APP_BACKGROUND } from '../createShared';
import { dashboardContentViewportHeight } from './SettingsBackButton';

export default function StoryFormLoading({ label = 'Loading story' }: { label?: string }) {
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-label={label}
      sx={{
        minHeight: dashboardContentViewportHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: APP_BACKGROUND,
      }}
    >
      <LoadingBook />
    </Box>
  );
}
